import { createSelector } from 'redux-orm';

import orm from '../orm';
import { selectPath } from './router';

export const selectPointSystemForCurrentBoard = createSelector(
  orm,
  (state) => selectPath(state).boardId,
  ({ Board, PointSystem }, boardId) => {
    if (!boardId) {
      console.log('[selectPointSystemForCurrentBoard] boardId не найден');
      return null;
    }

    const boardModel = Board.withId(boardId);
    if (!boardModel) {
      console.log('[selectPointSystemForCurrentBoard] Board не найден для boardId:', boardId);
      return null;
    }

    // Проверяем все PointSystems в ORM
    const allPointSystems = PointSystem.all().toRefArray();
    console.log('[selectPointSystemForCurrentBoard] Всего PointSystems в ORM:', allPointSystems.length);
    if (allPointSystems.length > 0) {
      console.log('[selectPointSystemForCurrentBoard] PointSystems:', allPointSystems);
    }

    const pointSystemModel = boardModel.pointSystems.first();
    if (!pointSystemModel) {
      console.log('[selectPointSystemForCurrentBoard] PointSystem не найден для boardId:', boardId);
      // Пытаемся найти PointSystem по boardId напрямую
      const pointSystemByBoardId = PointSystem.all().filter({ boardId }).first();
      if (pointSystemByBoardId) {
        console.log('[selectPointSystemForCurrentBoard] Найден PointSystem напрямую по boardId:', pointSystemByBoardId.ref);
        return pointSystemByBoardId.ref;
      }
      return null;
    }

    console.log('[selectPointSystemForCurrentBoard] Найден PointSystem:', pointSystemModel.ref);
    return pointSystemModel.ref;
  },
);

export const makeSelectPointSystemByBoardId = () =>
  createSelector(
    orm,
    (_, boardId) => boardId,
    ({ Board }, boardId) => {
      if (!boardId) {
        return null;
      }

      const boardModel = Board.withId(boardId);
      if (!boardModel) {
        return null;
      }

      const pointSystemModel = boardModel.pointSystems.first();
      return pointSystemModel ? pointSystemModel.ref : null;
    },
  );

export default {
  selectPointSystemForCurrentBoard,
  makeSelectPointSystemByBoardId,
};

